// extracted by mini-css-extract-plugin
export default {"fixedTableHead":"ETFsList_fixedTableHead__eyZaY","red1":"ETFsList_red1__0JGgx","red2":"ETFsList_red2__5ZSOS","red3":"ETFsList_red3__7abSi","red4":"ETFsList_red4__BRCcu"};